import React from 'react';
import {OrderAmountLine} from '../../schema';
import PriceFormatter from '../../models/formatter/PriceFormatter';

type Props = {
  amount: number
  currency: string
  details: ReadonlyArray<OrderAmountLine>
}

export function PaidAmount({amount, currency, details}: Props) {
  return (
    <>
      {details.length > 0 &&
        <>
          {details.map((line, index) =>
            <>
              <div key={`paid_amount_${index}`} className="grid grid-cols-2 gap-x-2">
                <div key={`paid_amount_${index}_1`} className={line.important ? 'font-bold' : ''}>{line.caption}</div>
                <div key={`paid_amount_${index}_2`}
                     className={line.important ? 'font-bold' : ''}>{PriceFormatter.format(line.amount)}</div>
              </div>
              {line.subLines.length > 0 &&
                line.subLines.map((subLine, subIndex) =>
                  <div key={`paid_amount_${index}_${subIndex}`} className="grid grid-cols-2 gap-x-2 pl-3">
                    <div key={`paid_amount_${index}_${subIndex}_1`}>{subLine.caption}</div>
                    <div key={`paid_amount_${index}_${subIndex}_2`}>{PriceFormatter.format(subLine.amount)}</div>
                  </div>
                )
              }
            </>
          )}
        </>
      }
      {details.length == 0 &&
        PriceFormatter.format({
          currency,
          amount
        })
      }
    </>
  );
}
